'use client'

import { getLocaleUrl } from '@ventanas95dev/runtime/urls'

import Link from 'next/link'
import type { ReactNode } from 'react'

import {
  REGION_CHANGE_EVENT,
  REGION_COOKIE_MAX_AGE,
  REGION_COOKIE_NAME,
} from '@/helpers/regionPreference'

type RegionLinkProps = {
  children: ReactNode
  className?: string
  slug: string
}

export function RegionLink({ children, className, slug }: RegionLinkProps) {
  function rememberRegion() {
    try {
      const secure = window.location.protocol === 'https:' ? '; Secure' : ''
      document.cookie = `${REGION_COOKIE_NAME}=${encodeURIComponent(slug)}; Path=/; Max-Age=${REGION_COOKIE_MAX_AGE}; SameSite=Lax${secure}`
    } catch {
      // Choosing a region must still work when the browser blocks cookies.
    }
    window.dispatchEvent(new Event(REGION_CHANGE_EVENT))
  }

  return (
    <Link
      className={className}
      href={getLocaleUrl(slug)}
      onClick={rememberRegion}
      onAuxClick={(event) => {
        if (event.button === 1) rememberRegion()
      }}
      prefetch={false}
    >
      {children}
    </Link>
  )
}
